module.exports = {
      id: "unchecked-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-99dfb162d59834e1e55e619b64a45f56.svg#unchecked",
      toString: function () {
        return this.url;
      }
    }